import {
  ADD_CONTRACTOR,
  ADD_CONTRACTOR_FAIL,
  ADD_CONTRACTOR_SUCCESS,
  ADD_SERVICE,
  ADD_SERVICE_FAIL,
  ADD_SERVICE_SUCCESS,
  ADD_VISITOR,
  ADD_VISITOR_FAIL,
  ADD_VISITOR_SUCCESS,
  CONTRACTOR_LIST,
  CONTRACTOR_LIST_FAIL,
  CONTRACTOR_LIST_SUCCESS,
  CONTRACTOR_STATUS,
  CONTRACTOR_STATUS_FAIL,
  CONTRACTOR_STATUS_SUCCESS,
  REMOVE_VISITOR_FILE,
  REMOVE_VISITOR_FILE_FAIL,
  REMOVE_VISITOR_FILE_SUCCESS,
  SERVICE_LIST,
  SERVICE_LIST_FAIL,
  SERVICE_LIST_SUCCESS,
  UPDATE_CONTRACTOR,
  UPDATE_CONTRACTOR_FAIL,
  UPDATE_CONTRACTOR_SUCCESS,
  UPDATE_LOCATION,
  UPDATE_LOCATION_FAIL,
  UPDATE_LOCATION_SUCCESS,
  UPDATE_SERVICE,
  UPDATE_SERVICE_FAIL,
  UPDATE_SERVICE_SUCCESS,
  UPDATE_VISITOR,
  UPDATE_VISITOR_FAIL,
  UPDATE_VISITOR_SUCCESS,
  VISITOR_LIST,
  VISITOR_LIST_FAIL,
  VISITOR_LIST_SUCCESS,
} from "./actionTypes";

export const updateLocation = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_LOCATION,
  payload: { data, onSuccess, onError },
});

export const updateLocationSuccess = (data = {}) => ({
  type: UPDATE_LOCATION_SUCCESS,
  payload: data,
});

export const updateLocationFail = (data = {}) => ({
  type: UPDATE_LOCATION_FAIL,
  payload: data,
});

export const updateLocationService = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_SERVICE,
  payload: { data, onSuccess, onError },
});

export const updateLocationServiceSuccess = (data = {}) => ({
  type: UPDATE_SERVICE_SUCCESS,
  payload: data,
});

export const updateLocationServiceFail = (data = {}) => ({
  type: UPDATE_SERVICE_FAIL,
  payload: data,
});

export const updateContractor = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_CONTRACTOR,
  payload: { data, onSuccess, onError },
});

export const updateContractorSuccess = (data = {}) => ({
  type: UPDATE_CONTRACTOR_SUCCESS,
  payload: data,
});

export const updateContractorFail = (data = {}) => ({
  type: UPDATE_CONTRACTOR_FAIL,
  payload: data,
});

export const contractorStatus = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: CONTRACTOR_STATUS,
  payload: { data, onSuccess, onError },
});

export const contractorStatusSuccess = (data = {}) => ({
  type: CONTRACTOR_STATUS_SUCCESS,
  payload: data,
});

export const contractorStatusFail = (data = {}) => ({
  type: CONTRACTOR_STATUS_FAIL,
  payload: data,
});

export const removeVisitorFile = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: REMOVE_VISITOR_FILE,
  payload: { data, onSuccess, onError },
});

export const removeVisitorFileSuccess = (data = {}) => ({
  type: REMOVE_VISITOR_FILE_SUCCESS,
  payload: data,
});

export const removeVisitorFileFail = (data = {}) => ({
  type: REMOVE_VISITOR_FILE_FAIL,
  payload: data,
});

export const updateVisitor = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_VISITOR,
  payload: { data, onSuccess, onError },
});

export const updateVisitorSuccess = (data = {}) => ({
  type: UPDATE_VISITOR_SUCCESS,
  payload: data,
});

export const updateVisitorFail = (data = {}) => ({
  type: UPDATE_VISITOR_FAIL,
  payload: data,
});

export const addVisitor = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_VISITOR,
  payload: { data, onSuccess, onError },
});

export const addVisitorSuccess = (data = {}) => ({
  type: ADD_VISITOR_SUCCESS,
  payload: data,
});

export const addVisitorFail = (data = {}) => ({
  type: ADD_VISITOR_FAIL,
  payload: data,
});

export const visitorList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: VISITOR_LIST,
  payload: { data, onSuccess, onError },
});

export const visitorListSuccess = (data = {}) => ({
  type: VISITOR_LIST_SUCCESS,
  payload: data,
});

export const visitorListFail = (data = {}) => ({
  type: VISITOR_LIST_FAIL,
  payload: data,
});

export const locationServiceList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: SERVICE_LIST,
  payload: { data, onSuccess, onError },
});

export const locationServiceListSuccess = (data = {}) => ({
  type: SERVICE_LIST_SUCCESS,
  payload: data,
});

export const locationServiceListFail = (data = {}) => ({
  type: SERVICE_LIST_FAIL,
  payload: data,
});

export const addLocationService = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_SERVICE,
  payload: { data, onSuccess, onError },
});

export const addLocationServiceSuccess = (data = {}) => ({
  type: ADD_SERVICE_SUCCESS,
  payload: data,
});

export const addLocationServiceFail = (data = {}) => ({
  type: ADD_SERVICE_FAIL,
  payload: data,
});

export const contractorList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: CONTRACTOR_LIST,
  payload: { data, onSuccess, onError },
});

export const contractorListSuccess = (data = {}) => ({
  type: CONTRACTOR_LIST_SUCCESS,
  payload: data,
});

export const contractorListFail = (data = {}) => ({
  type: CONTRACTOR_LIST_FAIL,
  payload: data,
});

export const addContractor = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_CONTRACTOR,
  payload: { data, onSuccess, onError },
});

export const addContractorSuccess = (data = {}) => ({
  type: ADD_CONTRACTOR_SUCCESS,
  payload: data,
});

export const addContractorFail = (data = {}) => ({
  type: ADD_CONTRACTOR_FAIL,
  payload: data,
});
